import { type BookingClient } from '../../../models/Scheduling'

export const CLIENT_EMAIL_BLOCKS_SEND_REASON = 'No client has an email address.'

export const hasClientEmail = (client: BookingClient): boolean => Boolean(client.email?.trim())

export const noClientHasEmail = (clients: BookingClient[]): boolean => clients.length > 0 && !clients.some(hasClientEmail)
